"use client"

import {Input} from "@/components/ui/input";
import {Post} from "@/root/payload-types";
import {Dispatch, SetStateAction, useState} from "react";
import {Headline} from "@/components/ui/headline";
import {NewsCarousel} from "@/components/custom/carousel/newsCarousel";
import {Separator} from "@/components/ui/separator";
import {useTranslations} from "@/contexts/TranslationContext";
import {ArticleCard} from "@/components/custom/cards/articleCard";

interface NewsSearchProps {
    news: Post[];
    searchResults: Post[];
    setSearchResults?: Dispatch<SetStateAction<Post[]>>;
    view?: "list" | "grid" | "carousel";
}

export function NewsSearch({ news, searchResults, setSearchResults, view = "carousel" }: NewsSearchProps) {
    const t = useTranslations();

    // TODO: very basic search, need improvement
    function handleSearch(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value.toLowerCase();

        if (value === "") {
            setSearchResults?.([]);
            return;
        }

        const results: typeof news = [];

        for (const entry of news) {
            if (!entry.content) continue;

            let titleMatch = false;
            for (const contentEntry of entry.content) {
                if (contentEntry.title.toLowerCase().includes(value)) {
                    titleMatch = true;
                    break;
                }
            }

            if (titleMatch) {
                results.push(entry);
                continue;
            }

            if (entry.user?.toLowerCase().includes(value)) {
                results.push(entry);
            }

            const associatedProductGroups = JSON.parse(entry.associatedProductGroups!) as string[];
            if(associatedProductGroups?.includes(value)) {
                results.push(entry);
            }
        }

        setSearchResults?.(results);
    }


    return (
        <>
            <Input className={"w-full"} placeholder={t["newsPage.search.placeholder"]} onChange={handleSearch} />
            {(searchResults && searchResults.length > 0) && (
                <div className={"flex flex-col"}>
                    <Headline variant={"h3"} size={"lg"}>
                        Suchergebnisse:
                    </Headline>
                    {view === "carousel" && (
                        <>
                            <NewsCarousel posts={searchResults} useAbsolutePath={true} />
                            <div className={"p-2 h-2"}>
                                <Separator />
                            </div>
                        </>
                    )}
                    {view === "list" && (
                        <div className={"flex flex-col gap-4"}>
                            {searchResults.map((post) => (
                                <ArticleCard
                                    key={post.id}
                                    bgColor={"primary"}
                                    url={`news/${post.id}`}
                                    post={post}
                                    useAbsolutePath={false}
                                    view={"list"}
                                />
                            ))}
                        </div>
                    )}
                </div>
            )}
        </>
    )
}